import { Phone, ShieldCheck, Clock, Wrench, HeartHandshake } from "lucide-react";

const REASONS = [
  {
    icon: ShieldCheck,
    title: "Licensed & Experienced",
    desc: "Our plumbers are fully licensed and trained to handle residential and commercial plumbing safely and correctly.",
  },
  {
    icon: Clock,
    title: "Fast Same-Day Service",
    desc: "We respond quickly to emergencies and scheduled jobs to prevent water damage and costly repairs.",
  },
  {
    icon: Wrench,
    title: "Clear, Upfront Pricing",
    desc: "You get clear pricing before work starts. No hidden fees or surprise charges after the job is done.",
  },
  {
    icon: HeartHandshake,
    title: "Honest With Every Client",
    desc: "We tell you what you need — not what makes us more money. Always.",
  },
];

export default function WhyChooseUs() {
  return (
    <section id="why-choose-us" className="max-w-[90%] xl:max-w-6xl mx-auto space-y-10">

      {/* Header row */}
      <div className="grid grid-cols-1 gap-6">
        <div className="space-y-4">
          <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full">
            Why Us
          </div>
          <h2 className="font-black text-gray-900 text-4xl lg:text-5xl tracking-tight leading-tight">
            Why Choose Us
          </h2>
          <p className="text-gray-500 text-lg leading-relaxed max-w-xl">
            Fast, reliable plumbing from licensed professionals. We fix leaks, clogs, pipes, and water heaters with skill and honesty — same day.
          </p>
        </div>
        <div className="">
          <a
            href="tel:(312) 555-0147"
            className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 transition-colors text-white font-bold px-6 py-3.5 rounded-xl shadow-md shadow-blue-600/25 text-sm"
          >
            <Phone className="w-4 h-4" /> Call Us for Fixes
          </a>
        </div>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {REASONS.map(({ icon: Icon, title, desc }) => (
          <div key={title} className="bg-white border border-gray-100 rounded-2xl p-6 shadow-sm flex flex-col gap-4 hover:shadow-lg hover:-translate-y-1 transition-all duration-300">
            <div className="w-11 h-11 bg-blue-50 rounded-xl flex items-center justify-center">
              <Icon className="w-5 h-5 text-blue-600" />
            </div>
            <div className="space-y-1.5">
              <h5 className="font-bold text-gray-900 text-[15px]">{title}</h5>
              <p className="text-sm text-gray-500 leading-relaxed">{desc}</p>
            </div>
          </div>
        ))}
      </div>

    </section>
  );
}